import React from "react";
import "./OurProducts.css";
import ProductList from "../../components/ProductList/ProductList";
import HeroSection from "../../components/Hero/HeroSection";
import WhatsAppIcon from "../../components/WhatsAppIcon/WhatsAppIcon";
import AOS from "aos";
import { useEffect } from "react";
import data from "../../data/index.json";

function OurProducts() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);

  return (
    <div>
      <div className="product-page">
        <HeroSection>
          <h1 className="hero-text-home">
            <span className="block-text">{data.siteContent.pageHeaders.products}</span>
          </h1>
        </HeroSection>

        <div>
          <p className="para-product" data-aos="fade-up">
            {data.siteContent.productsPage.description.line1}
          </p>
          <p className="para-product2" data-aos="fade-up">
            {data.siteContent.productsPage.description.line2}
          </p>
        </div>

        <ProductList products={data.products} />
        <WhatsAppIcon />
      </div>
    </div>
  );
}

export default OurProducts;
